import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { CustomerTaskForm } from "../components";

export const CreateCustomerTask: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get("customerId");

  return (
    <>
      <Header
        title="Tâche"
        subtitle="Créer une nouvelle tâche"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/customer-tasks`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouvelle tâche" />
          <CustomerTaskForm
            customerId={customerId ? +customerId : undefined}
            onCompleted={() => navigate("/customer-tasks")}
          />
        </div>
      </div>
    </>
  );
};
